import { SnowflakeCheckIcon } from './SnowflakeCheckIcon';

/**
 * author: Michael Irigoyen
 * id F489E6B1-12CD-4847-B039-8577751B2DFE
 * name snowflake-check
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snowflake-check.svg
 * tags
 * - Weather 
 */
export const SnowflakeApproveIcon = SnowflakeCheckIcon;
export default SnowflakeApproveIcon